// Module
var code = "<div class=\"mob-loader\"> <div class=\"mob-loader-pokegif\"></div> <h1>LOADING... <p>This may take a while</p> </h1> </div> ";
// Exports
export default code;